import { useEffect } from 'react'
import { KURSNAMN, SAJTNAMN } from './site'

export { SAJTNAMN }

/** Bygger sidtiteln på samma sätt överallt: "Sidans namn – <kursnamn>".
 *  Suffixet är avsiktligt kortare än SAJTNAMN — Google klipper titlar runt
 *  60 tecken, och "digitalt läromedel" behöver bara stå på startsidan. */
export const sidtitel = (titel?: string): string => (titel ? `${titel} – ${KURSNAMN}` : SAJTNAMN)

/** Håller dokumenttiteln i synk vid klientnavigering. Förrenderingen sätter
 *  samma titel statiskt i <head>, så crawlers behöver aldrig den här hooken —
 *  den finns för bokmärken, delningar och webbläsarhistorik. */
export function useSidTitel(titel?: string): void {
  useEffect(() => {
    document.title = sidtitel(titel)
  }, [titel])
}
